<template>
  <div class="information" v-if="newInfo && newInfo.length > 0">
    <div class="w">
      <divider class="divider" chinese="最新资讯" english="MOST CURRENT INFORMATION" />
      <div class="info-con">
        <div class="info-item" v-for="(item, index) in newInfo" :key="item.id" @click="handleNewInfoClick(item)">
          <img v-if="index === 0" src="@/assets/images/information1.png" alt="">
          <img v-if="index === 1" src="@/assets/images/information2.png" alt="">
          <img v-if="index === 2" src="@/assets/images/information3.png" alt="">
          <img v-if="index === 3" src="@/assets/images/information4.png" alt="">
          <img v-if="index === 4" src="@/assets/images/information5.png" alt="">
          <img v-if="index === 5" src="@/assets/images/information6.png" alt="">
          <div class="text-wrap">
            <div class="title-wrap">
              <p class="title">{{ item.contentTitle }}</p>
              <p class="more">查看详情>></p>
            </div>
            <p class="info-contariner">{{ item.content }}</p>
          </div>
        </div>
      </div>
      <div class="more-btn" @click="handleMore">
        查看更多>>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/common/divider';
import http from '@/http/index';
export default {
  data () {
    return {
      newInfo: []
    };
  },
  created () {
    const abbr = window.localStorage.getItem('pcs_org_abbr');
    if (abbr) {
      this.acquireSecondPortalContentListNew(abbr);
    }
  },
  methods: {
    handleNewInfoClick (data) {
      this.$router.push({
        name: 'announcementDetail',
        params: {
          blockName: data.blockName,
          id: data.id
        }
      });
      this.$store.state.announcementBlockName = data.blockName;
    },
    handleMore () {
      this.$router.push({
        name: 'announcement'
      });
    },
    acquireSecondPortalContentListNew (abbr) {
      http.acquireSecondPortalContentListNew(abbr).then(res => {
        // 建议加一层安全判断，避免 res.data 为 null
        if (res && res.data && Array.isArray(res.data.data)) {
          this.newInfo = res.data.data;
        } else {
          this.newInfo = [];
        }
      }).catch(err => {
        console.warn('获取最新资讯失败:', err);
        this.newInfo = []; // 确保出错时也不显示
      });
    }
  },
  components: {
    divider
  }
};
</script>

<style lang="scss" scoped>
.information {
  background: rgba(9, 9, 10, .05);
  padding: 30px 0;

  .w {
    @include container(1200px);

    .info-con {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .info-item {
        width: 590px;
        height: 140px;
        background: #fff;
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
        border-radius: 6px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;

        &:hover {
          .text-wrap {
            .title-wrap {
              .title {
                color: $el-main-color;
              }
            }
          }
        }

        img {
          display: block;
          width: 100px;
          height: 100px;
          margin-right: 20px;
        }

        .text-wrap {
          padding: 10px 0;
          flex: 1;

          .title-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 9px;

            .title {
              width: 304px;
              font-size: 18px;
              height: 22px;
              overflow: hidden;
              color: #333;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
            }

            .more {
              color: $el-main-color;
            }
          }

          .info-contariner {
            height: 48px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(128, 128, 128, .7);
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .more-btn {
      width: 116px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      margin: 10px auto 0;
      border: 1px solid $el-main-color;
      border-radius: 20px;
      color: $el-main-color;
      cursor: pointer;

      &:hover {
        color: #fff;
        background: $el-main-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/newInformation.vue